import React from 'react';
import { MetaTags as Tags } from 'react-meta-tags';
import config from 'config';

const MetaTags = ({ creative, view = '' }) => {
  const name = creative.name || '';
  const mediaAsset = !!creative.media_asset?.poster_image_file_attachment?.file;
  const shareView = view === 'share';
  const title = shareView ? 'Preview' : `${name} | Preview`;
  return (
    <Tags>
      <title>{title}</title>
      <meta name="description" content={`Preview the "${name}" creative`} />
      <meta property="og:description" content={`Preview the "${name}" creative`} />
      {mediaAsset && <meta property="og:image" content={`${config.fileHost}${creative.media_asset.poster_image_file_attachment.file}`} />}
      <meta property="og:url" content={window.location.href} />
    </Tags>
  );
}

export default MetaTags;
